import React from "react";

const Stretch = ({ children, style }) => {
  return (
    <div className="deal-stretch" style={style}>
      {children}
    </div>
  );
};

export { Stretch };
